// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__znyAW","noInteraction":"EventWrapper_noInteraction__U5d0q","pointerPassthrough":"EventWrapper_pointerPassthrough__3BFpi"};